export default function PasswordInput ({ id, value, onChange, children, minLength = 12, required = true, className = '' }) {
  return (
    <div className={`form-group ${className}`}>
      {children}
      <input
        type="password"
        className="form-control"
        id={id}
        value={value}
        onChange={onChange}
        minLength={minLength}
        required={required}
      />
      {
        <progress
          value={value.length}
          max={minLength}
          className={`mt-3 rounded w-100 ${value.length < minLength ? 'progress--danger' : 'progress--success'}`}
        />
      }
    </div>
  )
}
